import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { InvoiceLineItem } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Amount } from "@design-system/Amount/Amount";
import { useAccrualAwareTableMeta } from "@hooks/view/accrualAwareTableMeta";
import { getInvoiceLineOpenAmount } from "@common/helpers/accrual/openAmount";
import { applyInvoiceLineItemDisplaySign } from "@common/helpers/lineItems";
import { InvoiceLineItemsViewCallbacks } from "../types";

export const OpenAmountCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, InvoiceLineItem, number>) => {
        const lineItem = row.original;
        const { accrualEntityIds, isLoadingAccrualLedgers } =
            useAccrualAwareTableMeta<
                InvoiceLineItemsViewCallbacks,
                InvoiceLineItem
            >(table);

        return (
            <ViewTableCell>
                {isLoadingAccrualLedgers ? (
                    "-"
                ) : (
                    <Amount
                        amount={applyInvoiceLineItemDisplaySign(
                            lineItem.kind,
                            getInvoiceLineOpenAmount(
                                lineItem,
                                accrualEntityIds,
                            ),
                        )}
                        showNegative
                    />
                )}
            </ViewTableCell>
        );
    },
);
